import { graphql } from '../gql';

export const getUser = graphql(`
  query GetUser($userId: ID!) {
    getUser(id: $userId) {
      error {
        code
        message
      }
      user {
        id
        createdAt
        email
        vendors {
          id
          name
        }
        uuid
      }
    }
  }
`);
